import React, { Component } from "react";
import classNames from "../../../../utils/classNames";

import "./Sidebar.css";

import withTranslations from '../../../../utils/translations/withTranslations';

class Sidebar extends Component {
  handleClick(item) {
    if (!this.isActive(item)) {
      return;
    }

    this.props.goTo(item);
  }

  isActive(item) {
    return this.props.sidebar[item];
  }

  render() {
    const { items, translate } = this.props;

    return (
      <div className="Fiche__Sidebar">
        {Object.keys(items).map((item, i) => (
          <div key={item}>
            <div
              className={classNames(
                "Fiche__Sidebar__Divider",
                this.isActive(item) && "Fiche__Sidebar__Divider--active"
              )}
            />
            <div
              className={classNames(
                "Fiche__Sidebar__Item",
                this.isActive(item) && "Fiche__Sidebar__Item--active"
              )}
              onClick={() => this.handleClick(item)}
            >
              <div className="Fiche__Sidebar__Item__Number">
                <span>{i + 1}</span>
              </div>
              <div className="Fiche__Sidebar__Item__Name">{translate(`fiche.items.${item}`)}</div>
            </div>
          </div>
        ))}
      </div>
    );
  }
}

export default withTranslations(Sidebar);
